var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-3",attrs:{"disabled":_vm.disabled,"color":"primary"},on:{"click":_vm.renderDocs}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" mdi-printer-outline ")])],1)]}}])},[_vm._v(" lade ein Archiv (.zip) aller"),_c('br'),_vm._v(" Schülerzeugnisse herunter. ")])}
var staticRenderFns = []

export { render, staticRenderFns }